import * as Yup from "yup";
import { END_OF_TODAY_DATE } from "core/date-helpers";

export const diagnosticValidation = Yup.object({
  date_time: Yup.date()
    .label("Diagnostic Date")
    .max(
      END_OF_TODAY_DATE,
      "Diagnosis Date cannot be later than the current date"
    )
    .typeError("Diagnosis Date must be a valid date")
    .required()
    .nullable(),
  description: Yup.string()
    .label("Description")
    .required()
    .nullable(),
  recommendation: Yup.string()
    .label("Recommendation")
    .nullable()
});
